import { createContext } from 'react';

import { INotificationContex } from './types';

export const NotificationContext = createContext<
  INotificationContex | undefined
>(undefined);
